import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=f1dc284c&scoped=true&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"
import style0 from "./StatusDropdown.vue?vue&type=style&index=0&id=f1dc284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dc284c",
  null
  
)

export default component.exports